module.exports = __webpack_public_path__ + "627935e06d24a8d1aea0f38047906da5.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W8.jpg
// module id = 3498
// module chunks = 0